import * as d3 from "d3";
import { getRadiusForGroup } from "./graphUtility";

function setupSimulation(nodes, links, context) {
    
    const { simulation, linkParent, nodeParent, labelParent } = context;
    if (simulation.current) {
        simulation.current.stop();
    }

    simulation.current = d3.forceSimulation(nodes)
        .force("link", d3.forceLink(links).id(d => d.id).distance(500))
        .force("charge", d3.forceManyBody().strength(-2000).distanceMax(3000))
        .force("attractMainNodeToCenter", attractMainNodeToCenter)
        .force("repelSameGroup", forceGroupRepel(2000))
        .force("collision", d3.forceCollide().radius(d => getRadiusForGroup(d.group) + 35).strength(1))

    simulation.current.on("tick", () => {
        linkParent.current
            .attr("x1", d => d.source.x)
            .attr("y1", d => d.source.y)
            .attr("x2", d => d.target.x)
            .attr("y2", d => d.target.y);

        nodeParent.current
            .attr("transform", d => `translate(${d.x}, ${d.y})`);
        labelParent.current
            .attr("x", d => d.x)
            .attr("y", d => d.y);
    });

    function attractMainNodeToCenter(alpha) {
        var strength = 1;
        for (const d of nodes) {
            if (d.group === 0) {
                d.x += (0 - d.x) * strength * alpha;
                d.y += (0 - d.y) * strength * alpha;
            }
        }
    }

    function forceGroupRepel(strength) {
        let nodes;

        function force(alpha) {
            nodes.forEach(function (n1) {
                nodes.forEach(function (n2) {
                    if (n1.parent === n2.parent && n1 !== n2) {
                        // Calculate repulsive force
                        let dx = n1.x - n2.x;
                        let dy = n1.y - n2.y;
                        let distance = Math.sqrt(dx * dx + dy * dy);
                        let force = strength * alpha / distance;

                        // Apply the force
                        n1.vx += (dx / distance) * force;
                        n1.vy += (dy / distance) * force;
                        n2.vx -= (dx / distance) * force;
                        n2.vy -= (dy / distance) * force;
                    }
                });
            });
        }

        force.initialize = function (_nodes) {
            nodes = _nodes;
        };

        return force;
    }
}

export {setupSimulation }